export function initMetaPixel(pixelId: string) {
  if (typeof window === 'undefined') return

  // Avoid double-initialization
  if ((window as any).fbq) return

  const f = window as any
  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)
  ;(window as any).fbq('init', pixelId)
  ;(window as any).fbq('track', 'PageView')
}
